// extracted by mini-css-extract-plugin
export default {"container":"eMrGv2","icon":"nMx01h"};